import createReactComponent from '../createReactComponent';
export default createReactComponent('frame', 'Frame', [["path",{"d":"M21 6.6H3m18 10.8H3M6.6 3v18M17.4 3v18","key":"svg-0"}]]);